import moment from 'moment';

const formats = [
  'DD.MM.YYYY',
  'YYYY.MM.DD',
  'DD-MM-YYYY',
  'YYYY-MM-DD',
  'DD/MM/YYYY',
  'YYYY/MM/DD',
];

export const allowedDateFormats = Object.defineProperties(formats, {
  string: {
    get() {
      return this.join(', ');
    },
  },
});

export const baseFormat = formats[0];

export const isValid = (value) => moment(value, formats, true).isValid();
export { moment as dateTime };
